import { createPinia } from "pinia";
import { App } from "vue";

export function initializePinia(app: App) {
    const pinia = createPinia();
    app.use(pinia);
}